import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'cholesterol'

const answers: AnswerType[] = [
  {
    emoji: '🔥‍',
    title: 'pages.onboarding.cholesterol.options.high',
    value: 'high',
  },
  {
    emoji: '❗️',
    title: 'pages.onboarding.cholesterol.options.elevated',
    value: 'elevated',
  },
  {
    emoji: '✅',
    title: 'pages.onboarding.cholesterol.options.normal',
    value: 'normal',
  },
  {
    emoji: '❓',
    title: 'pages.onboarding.cholesterol.options.dontKnow',
    value: 'dont-know',
  },
]

export default function CholesterolPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your cholesterol level?",
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.cholesterol.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
